export default class ProjectDetailModal {
    constructor($el) {
        this.$el = $el;
        this.hashId = this.$el.querySelector('[data-hash-id]').dataset.hashId;
        this.$modalContainer = this.$el.querySelector('[data-modal-container]');
        this.$modal = this.$el.querySelector('[data-modal]');
        this.$btn = this.$el.querySelector('[data-btn-modal]');
        this.$select = this.$el.querySelector('[data-select-projects]');
        this.$error = this.$el.querySelector('.form__group--error');

        this.openModal = this.openModal.bind(this);
        this.chooseProject = this.chooseProject.bind(this);

        this.$btn.addEventListener('click', this.chooseProject);

        if (this.$error) {
            this.openModal();
        }
    }

    chooseProject(e) {
        e.preventDefault();
        this.$select.value = this.hashId;
        this.openModal();
    }

    openModal() {
        this.$modalContainer.classList.add('modal__container--open');
        this.$modal.classList.add('modal--open');
    }
}